import { ReactComponent as EnvelopeIcon } from "../lib/icons/Envelope.svg";
import { ReactComponent as PhoneIcon } from "../lib/icons/Phone.svg";
import { ReactComponent as UserIcon } from "../lib/icons/Home.svg";

export const conInfo = [
  {
    conIcon: <UserIcon className="h-[3.4375rem] fill-white"></UserIcon>,
    conTitle: "Management/ USA/ Canada",
    conCap: "Mr Shaurav ",
  },
  {
    conIcon: <PhoneIcon className="h-[3.4375rem] fill-white"></PhoneIcon>,
    conTitle: "Phone:",
    conCap: "+88 0171 298 4115",
  },
  {
    conIcon: <EnvelopeIcon className="h-[3.4375rem] fill-white"></EnvelopeIcon>,
    conTitle: "Email Address:",
    conCap: "shauravaub1985@gmail.com",
  },
];
